import { render } from "./PlanTrip.vue?vue&type=template&id=63bf87e7"
import script from "./PlanTrip.vue?vue&type=script&lang=js"
export * from "./PlanTrip.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__